import PolicyTypes from './policyTypes'

export default PolicyTypes
